import type { LucideIcon } from "lucide-react"
import {
  Crown,
  Flame,
  Ticket,
  Star,
  Gamepad2,
  Zap,
  Trophy,
  Gift,
  Target,
  Swords,
  Rocket,
  Sparkles,
  DollarSign,
  Medal,
  Shield,
} from "lucide-react"

export const ICON_MAP: Record<string, LucideIcon> = {
  crown: Crown,
  flame: Flame,
  ticket: Ticket,
  star: Star,
  gamepad2: Gamepad2,
  zap: Zap,
  trophy: Trophy,
  gift: Gift,
  target: Target,
  swords: Swords,
  rocket: Rocket,
  sparkles: Sparkles,
  dollar: DollarSign,
  medal: Medal,
  shield: Shield,
}

export const ICON_NAMES = Object.keys(ICON_MAP)

export function getEventIcon(iconName: string): LucideIcon {
  return ICON_MAP[iconName] || Trophy
}
